import React from "react";
import { PlusOutlined } from "@ant-design/icons";

interface AddItemButtonProps {
    onAdd: () => void;
    currentCount: number;
    maxItems: number;
    itemName?: string;
}

const AddItemButton = ({
    onAdd,
    currentCount,
    maxItems,
}: AddItemButtonProps) => {
    const isMaxReached = currentCount >= maxItems;

    return (
        <button
            type="button"
            onClick={onAdd}
            className={`btn ${isMaxReached ? "btn-secondary" : "btn-primary"} d-flex align-items-center gap-2`}
            disabled={isMaxReached}
            title={isMaxReached ? `Limit reached (${maxItems})` : "Add new item"}
            style={{
                borderRadius: "50px",
                padding: "7px 16px",
                fontSize: "14px",
                fontWeight: 600,
                transition: "all 0.2s ease",
                lineHeight: 1.25,
            }}
        >
            <PlusOutlined style={{ fontSize: "14px", fontWeight: "bold" }} />
            <span>{isMaxReached ? `Limit (${maxItems})` : "Add"}</span>
        </button>
    );
};

export default AddItemButton;
